module.exports = __webpack_public_path__ + "img/calendar-lightgrey24.8f914549.svg";